const countryCode = [
  {
    en: 'Afghanistan',
    code: 'AF',
    iso3: 'AFG',
    zone: '93',
    emoji: '🇦🇫',
  },
  {
    en: 'Aland Islands',
    code: 'AX',
    iso3: 'ALA',
    zone: '358-18',
    emoji: '🇦🇽',
  },
  {
    en: 'Albania',
    code: 'AL',
    iso3: 'ALB',
    zone: '355',
    emoji: '🇦🇱',
  },
  {
    en: 'Algeria',
    code: 'DZ',
    iso3: 'DZA',
    zone: '213',
    emoji: '🇩🇿',
  },
  {
    en: 'American Samoa',
    code: 'AS',
    iso3: 'ASM',
    zone: '1-684',
    emoji: '🇦🇸',
  },
  {
    en: 'Andorra',
    code: 'AD',
    iso3: 'AND',
    zone: '376',
    emoji: '🇦🇩',
  },
  {
    en: 'Angola',
    code: 'AO',
    iso3: 'AGO',
    zone: '244',
    emoji: '🇦🇴',
  },
  {
    en: 'Anguilla',
    code: 'AI',
    iso3: 'AIA',
    zone: '1-264',
    emoji: '🇦🇮',
  },
  {
    en: 'Antarctica',
    code: 'AQ',
    iso3: 'ATA',
    zone: '672',
    emoji: '🇦🇶',
  },
  {
    en: 'Antigua and Barbuda',
    code: 'AG',
    iso3: 'ATG',
    zone: '1-268',
    emoji: '🇦🇬',
  },
  {
    en: 'Argentina',
    code: 'AR',
    iso3: 'ARG',
    zone: '54',
    emoji: '🇦🇷',
  },
  {
    en: 'Armenia',
    code: 'AM',
    iso3: 'ARM',
    zone: '374',
    emoji: '🇦🇲',
  },
  {
    en: 'Aruba',
    code: 'AW',
    iso3: 'ABW',
    zone: '297',
    emoji: '🇦🇼',
  },
  {
    en: 'Australia',
    code: 'AU',
    iso3: 'AUS',
    zone: '61',
    emoji: '🇦🇺',
  },
  {
    en: 'Austria',
    code: 'AT',
    iso3: 'AUT',
    zone: '43',
    emoji: '🇦🇹',
  },
  {
    en: 'Azerbaijan',
    code: 'AZ',
    iso3: 'AZE',
    zone: '994',
    emoji: '🇦🇿',
  },
  {
    en: 'Bahrain',
    code: 'BH',
    iso3: 'BHR',
    zone: '973',
    emoji: '🇧🇭',
  },
  {
    en: 'Bangladesh',
    code: 'BD',
    iso3: 'BGD',
    zone: '880',
    emoji: '🇧🇩',
  },
  {
    en: 'Barbados',
    code: 'BB',
    iso3: 'BRB',
    zone: '1-246',
    emoji: '🇧🇧',
  },
  {
    en: 'Belarus',
    code: 'BY',
    iso3: 'BLR',
    zone: '375',
    emoji: '🇧🇾',
  },
  {
    en: 'Belgium',
    code: 'BE',
    iso3: 'BEL',
    zone: '32',
    emoji: '🇧🇪',
  },
  {
    en: 'Belize',
    code: 'BZ',
    iso3: 'BLZ',
    zone: '501',
    emoji: '🇧🇿',
  },
  {
    en: 'Benin',
    code: 'BJ',
    iso3: 'BEN',
    zone: '229',
    emoji: '🇧🇯',
  },
  {
    en: 'Bermuda',
    code: 'BM',
    iso3: 'BMU',
    zone: '1-441',
    emoji: '🇧🇲',
  },
  {
    en: 'Bhutan',
    code: 'BT',
    iso3: 'BTN',
    zone: '975',
    emoji: '🇧🇹',
  },
  {
    en: 'Bolivia',
    code: 'BO',
    iso3: 'BOL',
    zone: '591',
    emoji: '🇧🇴',
  },
  {
    en: 'Bonaire, Sint Eustatius and Saba',
    code: 'BQ',
    iso3: 'BES',
    zone: '599',
    emoji: '🇧🇶',
  },
  {
    en: 'Bosnia and Herzegovina',
    code: 'BA',
    iso3: 'BIH',
    zone: '387',
    emoji: '🇧🇦',
  },
  {
    en: 'Botswana',
    code: 'BW',
    iso3: 'BWA',
    zone: '267',
    emoji: '🇧🇼',
  },
  {
    en: 'Bouvet Island',
    code: 'BV',
    iso3: 'BVT',
    zone: '0055',
    emoji: '🇧🇻',
  },
  {
    en: 'Brazil',
    code: 'BR',
    iso3: 'BRA',
    zone: '55',
    emoji: '🇧🇷',
  },
  {
    en: 'British Indian Ocean Territory',
    code: 'IO',
    iso3: 'IOT',
    zone: '246',
    emoji: '🇮🇴',
  },
  {
    en: 'Brunei',
    code: 'BN',
    iso3: 'BRN',
    zone: '673',
    emoji: '🇧🇳',
  },
  {
    en: 'Bulgaria',
    code: 'BG',
    iso3: 'BGR',
    zone: '359',
    emoji: '🇧🇬',
  },
  {
    en: 'Burkina Faso',
    code: 'BF',
    iso3: 'BFA',
    zone: '226',
    emoji: '🇧🇫',
  },
  {
    en: 'Burundi',
    code: 'BI',
    iso3: 'BDI',
    zone: '257',
    emoji: '🇧🇮',
  },
  {
    en: 'Cambodia',
    code: 'KH',
    iso3: 'KHM',
    zone: '855',
    emoji: '🇰🇭',
  },
  {
    en: 'Cameroon',
    code: 'CM',
    iso3: 'CMR',
    zone: '237',
    emoji: '🇨🇲',
  },
  {
    en: 'Canada',
    code: 'CA',
    iso3: 'CAN',
    zone: '1',
    emoji: '🇨🇦',
  },
  {
    en: 'Cape Verde',
    code: 'CV',
    iso3: 'CPV',
    zone: '238',
    emoji: '🇨🇻',
  },
  {
    en: 'Cayman Islands',
    code: 'KY',
    iso3: 'CYM',
    zone: '1-345',
    emoji: '🇰🇾',
  },
  {
    en: 'Central African Republic',
    code: 'CF',
    iso3: 'CAF',
    zone: '236',
    emoji: '🇨🇫',
  },
  {
    en: 'Chad',
    code: 'TD',
    iso3: 'TCD',
    zone: '235',
    emoji: '🇹🇩',
  },
  {
    en: 'Chile',
    code: 'CL',
    iso3: 'CHL',
    zone: '56',
    emoji: '🇨🇱',
  },
  {
    en: 'China',
    code: 'CN',
    iso3: 'CHN',
    zone: '86',
    emoji: '🇨🇳',
  },
  {
    en: 'Christmas Island',
    code: 'CX',
    iso3: 'CXR',
    zone: '61',
    emoji: '🇨🇽',
  },
  {
    en: 'Cocos (Keeling) Islands',
    code: 'CC',
    iso3: 'CCK',
    zone: '61',
    emoji: '🇨🇨',
  },
  {
    en: 'Colombia',
    code: 'CO',
    iso3: 'COL',
    zone: '57',
    emoji: '🇨🇴',
  },
  {
    en: 'Comoros',
    code: 'KM',
    iso3: 'COM',
    zone: '269',
    emoji: '🇰🇲',
  },
  {
    en: 'Congo',
    code: 'CG',
    iso3: 'COG',
    zone: '242',
    emoji: '🇨🇬',
  },
  {
    en: 'Cook Islands',
    code: 'CK',
    iso3: 'COK',
    zone: '682',
    emoji: '🇨🇰',
  },
  {
    en: 'Costa Rica',
    code: 'CR',
    iso3: 'CRI',
    zone: '506',
    emoji: '🇨🇷',
  },
  {
    en: "Cote D'Ivoire (Ivory Coast)",
    code: 'CI',
    iso3: 'CIV',
    zone: '225',
    emoji: '🇨🇮',
  },
  {
    en: 'Croatia',
    code: 'HR',
    iso3: 'HRV',
    zone: '385',
    emoji: '🇭🇷',
  },
  {
    en: 'Cuba',
    code: 'CU',
    iso3: 'CUB',
    zone: '53',
    emoji: '🇨🇺',
  },
  {
    en: 'Curaçao',
    code: 'CW',
    iso3: 'CUW',
    zone: '599',
    emoji: '🇨🇼',
  },
  {
    en: 'Cyprus',
    code: 'CY',
    iso3: 'CYP',
    zone: '357',
    emoji: '🇨🇾',
  },
  {
    en: 'Czech Republic',
    code: 'CZ',
    iso3: 'CZE',
    zone: '420',
    emoji: '🇨🇿',
  },
  {
    en: 'Democratic Republic of the Congo',
    code: 'CD',
    iso3: 'COD',
    zone: '243',
    emoji: '🇨🇩',
  },
  {
    en: 'Denmark',
    code: 'DK',
    iso3: 'DNK',
    zone: '45',
    emoji: '🇩🇰',
  },
  {
    en: 'Djibouti',
    code: 'DJ',
    iso3: 'DJI',
    zone: '253',
    emoji: '🇩🇯',
  },
  {
    en: 'Dominica',
    code: 'DM',
    iso3: 'DMA',
    zone: '1-767',
    emoji: '🇩🇲',
  },
  {
    en: 'Dominican Republic',
    code: 'DO',
    iso3: 'DOM',
    zone: '1-809 and 1-829',
    emoji: '🇩🇴',
  },
  {
    en: 'Ecuador',
    code: 'EC',
    iso3: 'ECU',
    zone: '593',
    emoji: '🇪🇨',
  },
  {
    en: 'Egypt',
    code: 'EG',
    iso3: 'EGY',
    zone: '20',
    emoji: '🇪🇬',
  },
  {
    en: 'El Salvador',
    code: 'SV',
    iso3: 'SLV',
    zone: '503',
    emoji: '🇸🇻',
  },
  {
    en: 'Equatorial Guinea',
    code: 'GQ',
    iso3: 'GNQ',
    zone: '240',
    emoji: '🇬🇶',
  },
  {
    en: 'Eritrea',
    code: 'ER',
    iso3: 'ERI',
    zone: '291',
    emoji: '🇪🇷',
  },
  {
    en: 'Estonia',
    code: 'EE',
    iso3: 'EST',
    zone: '372',
    emoji: '🇪🇪',
  },
  {
    en: 'Eswatini',
    code: 'SZ',
    iso3: 'SWZ',
    zone: '268',
    emoji: '🇸🇿',
  },
  {
    en: 'Ethiopia',
    code: 'ET',
    iso3: 'ETH',
    zone: '251',
    emoji: '🇪🇹',
  },
  {
    en: 'Falkland Islands',
    code: 'FK',
    iso3: 'FLK',
    zone: '500',
    emoji: '🇫🇰',
  },
  {
    en: 'Faroe Islands',
    code: 'FO',
    iso3: 'FRO',
    zone: '298',
    emoji: '🇫🇴',
  },
  {
    en: 'Fiji Islands',
    code: 'FJ',
    iso3: 'FJI',
    zone: '679',
    emoji: '🇫🇯',
  },
  {
    en: 'Finland',
    code: 'FI',
    iso3: 'FIN',
    zone: '358',
    emoji: '🇫🇮',
  },
  {
    en: 'France',
    code: 'FR',
    iso3: 'FRA',
    zone: '33',
    emoji: '🇫🇷',
  },
  {
    en: 'French Guiana',
    code: 'GF',
    iso3: 'GUF',
    zone: '594',
    emoji: '🇬🇫',
  },
  {
    en: 'French Polynesia',
    code: 'PF',
    iso3: 'PYF',
    zone: '689',
    emoji: '🇵🇫',
  },
  {
    en: 'French Southern Territories',
    code: 'TF',
    iso3: 'ATF',
    zone: '262',
    emoji: '🇹🇫',
  },
  {
    en: 'Gabon',
    code: 'GA',
    iso3: 'GAB',
    zone: '241',
    emoji: '🇬🇦',
  },
  {
    en: 'Gambia The',
    code: 'GM',
    iso3: 'GMB',
    zone: '220',
    emoji: '🇬🇲',
  },
  {
    en: 'Georgia',
    code: 'GE',
    iso3: 'GEO',
    zone: '995',
    emoji: '🇬🇪',
  },
  {
    en: 'Germany',
    code: 'DE',
    iso3: 'DEU',
    zone: '49',
    emoji: '🇩🇪',
  },
  {
    en: 'Ghana',
    code: 'GH',
    iso3: 'GHA',
    zone: '233',
    emoji: '🇬🇭',
  },
  {
    en: 'Gibraltar',
    code: 'GI',
    iso3: 'GIB',
    zone: '350',
    emoji: '🇬🇮',
  },
  {
    en: 'Greece',
    code: 'GR',
    iso3: 'GRC',
    zone: '30',
    emoji: '🇬🇷',
  },
  {
    en: 'Greenland',
    code: 'GL',
    iso3: 'GRL',
    zone: '299',
    emoji: '🇬🇱',
  },
  {
    en: 'Grenada',
    code: 'GD',
    iso3: 'GRD',
    zone: '1-473',
    emoji: '🇬🇩',
  },
  {
    en: 'Guadeloupe',
    code: 'GP',
    iso3: 'GLP',
    zone: '590',
    emoji: '🇬🇵',
  },
  {
    en: 'Guam',
    code: 'GU',
    iso3: 'GUM',
    zone: '1-671',
    emoji: '🇬🇺',
  },
  {
    en: 'Guatemala',
    code: 'GT',
    iso3: 'GTM',
    zone: '502',
    emoji: '🇬🇹',
  },
  {
    en: 'Guernsey and Alderney',
    code: 'GG',
    iso3: 'GGY',
    zone: '44-1481',
    emoji: '🇬🇬',
  },
  {
    en: 'Guinea',
    code: 'GN',
    iso3: 'GIN',
    zone: '224',
    emoji: '🇬🇳',
  },
  {
    en: 'Guinea-Bissau',
    code: 'GW',
    iso3: 'GNB',
    zone: '245',
    emoji: '🇬🇼',
  },
  {
    en: 'Guyana',
    code: 'GY',
    iso3: 'GUY',
    zone: '592',
    emoji: '🇬🇾',
  },
  {
    en: 'Haiti',
    code: 'HT',
    iso3: 'HTI',
    zone: '509',
    emoji: '🇭🇹',
  },
  {
    en: 'Heard Island and McDonald Islands',
    code: 'HM',
    iso3: 'HMD',
    zone: '672',
    emoji: '🇭🇲',
  },
  {
    en: 'Honduras',
    code: 'HN',
    iso3: 'HND',
    zone: '504',
    emoji: '🇭🇳',
  },
  {
    en: 'Hong Kong S.A.R.',
    code: 'HK',
    iso3: 'HKG',
    zone: '852',
    emoji: '🇭🇰',
  },
  {
    en: 'Hungary',
    code: 'HU',
    iso3: 'HUN',
    zone: '36',
    emoji: '🇭🇺',
  },
  {
    en: 'Iceland',
    code: 'IS',
    iso3: 'ISL',
    zone: '354',
    emoji: '🇮🇸',
  },
  {
    en: 'India',
    code: 'IN',
    iso3: 'IND',
    zone: '91',
    emoji: '🇮🇳',
  },
  {
    en: 'Indonesia',
    code: 'ID',
    iso3: 'IDN',
    zone: '62',
    emoji: '🇮🇩',
  },
  {
    en: 'Iran',
    code: 'IR',
    iso3: 'IRN',
    zone: '98',
    emoji: '🇮🇷',
  },
  {
    en: 'Iraq',
    code: 'IQ',
    iso3: 'IRQ',
    zone: '964',
    emoji: '🇮🇶',
  },
  {
    en: 'Ireland',
    code: 'IE',
    iso3: 'IRL',
    zone: '353',
    emoji: '🇮🇪',
  },
  {
    en: 'Israel',
    code: 'IL',
    iso3: 'ISR',
    zone: '972',
    emoji: '🇮🇱',
  },
  {
    en: 'Italy',
    code: 'IT',
    iso3: 'ITA',
    zone: '39',
    emoji: '🇮🇹',
  },
  {
    en: 'Jamaica',
    code: 'JM',
    iso3: 'JAM',
    zone: '1-876',
    emoji: '🇯🇲',
  },
  {
    en: 'Japan',
    code: 'JP',
    iso3: 'JPN',
    zone: '81',
    emoji: '🇯🇵',
  },
  {
    en: 'Jersey',
    code: 'JE',
    iso3: 'JEY',
    zone: '44-1534',
    emoji: '🇯🇪',
  },
  {
    en: 'Jordan',
    code: 'JO',
    iso3: 'JOR',
    zone: '962',
    emoji: '🇯🇴',
  },
  {
    en: 'Kazakhstan',
    code: 'KZ',
    iso3: 'KAZ',
    zone: '7',
    emoji: '🇰🇿',
  },
  {
    en: 'Kenya',
    code: 'KE',
    iso3: 'KEN',
    zone: '254',
    emoji: '🇰🇪',
  },
  {
    en: 'Kiribati',
    code: 'KI',
    iso3: 'KIR',
    zone: '686',
    emoji: '🇰🇮',
  },
  {
    en: 'Kosovo',
    code: 'XK',
    iso3: 'XKX',
    zone: '383',
    emoji: '🇽🇰',
  },
  {
    en: 'Kuwait',
    code: 'KW',
    iso3: 'KWT',
    zone: '965',
    emoji: '🇰🇼',
  },
  {
    en: 'Kyrgyzstan',
    code: 'KG',
    iso3: 'KGZ',
    zone: '996',
    emoji: '🇰🇬',
  },
  {
    en: 'Laos',
    code: 'LA',
    iso3: 'LAO',
    zone: '856',
    emoji: '🇱🇦',
  },
  {
    en: 'Latvia',
    code: 'LV',
    iso3: 'LVA',
    zone: '371',
    emoji: '🇱🇻',
  },
  {
    en: 'Lebanon',
    code: 'LB',
    iso3: 'LBN',
    zone: '961',
    emoji: '🇱🇧',
  },
  {
    en: 'Lesotho',
    code: 'LS',
    iso3: 'LSO',
    zone: '266',
    emoji: '🇱🇸',
  },
  {
    en: 'Liberia',
    code: 'LR',
    iso3: 'LBR',
    zone: '231',
    emoji: '🇱🇷',
  },
  {
    en: 'Libya',
    code: 'LY',
    iso3: 'LBY',
    zone: '218',
    emoji: '🇱🇾',
  },
  {
    en: 'Liechtenstein',
    code: 'LI',
    iso3: 'LIE',
    zone: '423',
    emoji: '🇱🇮',
  },
  {
    en: 'Lithuania',
    code: 'LT',
    iso3: 'LTU',
    zone: '370',
    emoji: '🇱🇹',
  },
  {
    en: 'Luxembourg',
    code: 'LU',
    iso3: 'LUX',
    zone: '352',
    emoji: '🇱🇺',
  },
  {
    en: 'Macau S.A.R.',
    code: 'MO',
    iso3: 'MAC',
    zone: '853',
    emoji: '🇲🇴',
  },
  {
    en: 'Madagascar',
    code: 'MG',
    iso3: 'MDG',
    zone: '261',
    emoji: '🇲🇬',
  },
  {
    en: 'Malawi',
    code: 'MW',
    iso3: 'MWI',
    zone: '265',
    emoji: '🇲🇼',
  },
  {
    en: 'Malaysia',
    code: 'MY',
    iso3: 'MYS',
    zone: '60',
    emoji: '🇲🇾',
  },
  {
    en: 'Maldives',
    code: 'MV',
    iso3: 'MDV',
    zone: '960',
    emoji: '🇲🇻',
  },
  {
    en: 'Mali',
    code: 'ML',
    iso3: 'MLI',
    zone: '223',
    emoji: '🇲🇱',
  },
  {
    en: 'Malta',
    code: 'MT',
    iso3: 'MLT',
    zone: '356',
    emoji: '🇲🇹',
  },
  {
    en: 'Man (Isle of)',
    code: 'IM',
    iso3: 'IMN',
    zone: '44-1624',
    emoji: '🇮🇲',
  },
  {
    en: 'Marshall Islands',
    code: 'MH',
    iso3: 'MHL',
    zone: '692',
    emoji: '🇲🇭',
  },
  {
    en: 'Martinique',
    code: 'MQ',
    iso3: 'MTQ',
    zone: '596',
    emoji: '🇲🇶',
  },
  {
    en: 'Mauritania',
    code: 'MR',
    iso3: 'MRT',
    zone: '222',
    emoji: '🇲🇷',
  },
  {
    en: 'Mauritius',
    code: 'MU',
    iso3: 'MUS',
    zone: '230',
    emoji: '🇲🇺',
  },
  {
    en: 'Mayotte',
    code: 'YT',
    iso3: 'MYT',
    zone: '262',
    emoji: '🇾🇹',
  },
  {
    en: 'Mexico',
    code: 'MX',
    iso3: 'MEX',
    zone: '52',
    emoji: '🇲🇽',
  },
  {
    en: 'Micronesia',
    code: 'FM',
    iso3: 'FSM',
    zone: '691',
    emoji: '🇫🇲',
  },
  {
    en: 'Moldova',
    code: 'MD',
    iso3: 'MDA',
    zone: '373',
    emoji: '🇲🇩',
  },
  {
    en: 'Monaco',
    code: 'MC',
    iso3: 'MCO',
    zone: '377',
    emoji: '🇲🇨',
  },
  {
    en: 'Mongolia',
    code: 'MN',
    iso3: 'MNG',
    zone: '976',
    emoji: '🇲🇳',
  },
  {
    en: 'Montenegro',
    code: 'ME',
    iso3: 'MNE',
    zone: '382',
    emoji: '🇲🇪',
  },
  {
    en: 'Montserrat',
    code: 'MS',
    iso3: 'MSR',
    zone: '1-664',
    emoji: '🇲🇸',
  },
  {
    en: 'Morocco',
    code: 'MA',
    iso3: 'MAR',
    zone: '212',
    emoji: '🇲🇦',
  },
  {
    en: 'Mozambique',
    code: 'MZ',
    iso3: 'MOZ',
    zone: '258',
    emoji: '🇲🇿',
  },
  {
    en: 'Myanmar',
    code: 'MM',
    iso3: 'MMR',
    zone: '95',
    emoji: '🇲🇲',
  },
  {
    en: 'Namibia',
    code: 'NA',
    iso3: 'NAM',
    zone: '264',
    emoji: '🇳🇦',
  },
  {
    en: 'Nauru',
    code: 'NR',
    iso3: 'NRU',
    zone: '674',
    emoji: '🇳🇷',
  },
  {
    en: 'Nepal',
    code: 'NP',
    iso3: 'NPL',
    zone: '977',
    emoji: '🇳🇵',
  },
  {
    en: 'Netherlands',
    code: 'NL',
    iso3: 'NLD',
    zone: '31',
    emoji: '🇳🇱',
  },
  {
    en: 'New Caledonia',
    code: 'NC',
    iso3: 'NCL',
    zone: '687',
    emoji: '🇳🇨',
  },
  {
    en: 'New Zealand',
    code: 'NZ',
    iso3: 'NZL',
    zone: '64',
    emoji: '🇳🇿',
  },
  {
    en: 'Nicaragua',
    code: 'NI',
    iso3: 'NIC',
    zone: '505',
    emoji: '🇳🇮',
  },
  {
    en: 'Niger',
    code: 'NE',
    iso3: 'NER',
    zone: '227',
    emoji: '🇳🇪',
  },
  {
    en: 'Nigeria',
    code: 'NG',
    iso3: 'NGA',
    zone: '234',
    emoji: '🇳🇬',
  },
  {
    en: 'Niue',
    code: 'NU',
    iso3: 'NIU',
    zone: '683',
    emoji: '🇳🇺',
  },
  {
    en: 'Norfolk Island',
    code: 'NF',
    iso3: 'NFK',
    zone: '672',
    emoji: '🇳🇫',
  },
  {
    en: 'North Korea',
    code: 'KP',
    iso3: 'PRK',
    zone: '850',
    emoji: '🇰🇵',
  },
  {
    en: 'North Macedonia',
    code: 'MK',
    iso3: 'MKD',
    zone: '389',
    emoji: '🇲🇰',
  },
  {
    en: 'Northern Mariana Islands',
    code: 'MP',
    iso3: 'MNP',
    zone: '1-670',
    emoji: '🇲🇵',
  },
  {
    en: 'Norway',
    code: 'NO',
    iso3: 'NOR',
    zone: '47',
    emoji: '🇳🇴',
  },
  {
    en: 'Oman',
    code: 'OM',
    iso3: 'OMN',
    zone: '968',
    emoji: '🇴🇲',
  },
  {
    en: 'Pakistan',
    code: 'PK',
    iso3: 'PAK',
    zone: '92',
    emoji: '🇵🇰',
  },
  {
    en: 'Palau',
    code: 'PW',
    iso3: 'PLW',
    zone: '680',
    emoji: '🇵🇼',
  },
  {
    en: 'Palestinian Territory Occupied',
    code: 'PS',
    iso3: 'PSE',
    zone: '970',
    emoji: '🇵🇸',
  },
  {
    en: 'Panama',
    code: 'PA',
    iso3: 'PAN',
    zone: '507',
    emoji: '🇵🇦',
  },
  {
    en: 'Papua New Guinea',
    code: 'PG',
    iso3: 'PNG',
    zone: '675',
    emoji: '🇵🇬',
  },
  {
    en: 'Paraguay',
    code: 'PY',
    iso3: 'PRY',
    zone: '595',
    emoji: '🇵🇾',
  },
  {
    en: 'Peru',
    code: 'PE',
    iso3: 'PER',
    zone: '51',
    emoji: '🇵🇪',
  },
  {
    en: 'Philippines',
    code: 'PH',
    iso3: 'PHL',
    zone: '63',
    emoji: '🇵🇭',
  },
  {
    en: 'Pitcairn Island',
    code: 'PN',
    iso3: 'PCN',
    zone: '870',
    emoji: '🇵🇳',
  },
  {
    en: 'Poland',
    code: 'PL',
    iso3: 'POL',
    zone: '48',
    emoji: '🇵🇱',
  },
  {
    en: 'Portugal',
    code: 'PT',
    iso3: 'PRT',
    zone: '351',
    emoji: '🇵🇹',
  },
  {
    en: 'Puerto Rico',
    code: 'PR',
    iso3: 'PRI',
    zone: '1-787 and 1-939',
    emoji: '🇵🇷',
  },
  {
    en: 'Qatar',
    code: 'QA',
    iso3: 'QAT',
    zone: '974',
    emoji: '🇶🇦',
  },
  {
    en: 'Reunion',
    code: 'RE',
    iso3: 'REU',
    zone: '262',
    emoji: '🇷🇪',
  },
  {
    en: 'Romania',
    code: 'RO',
    iso3: 'ROU',
    zone: '40',
    emoji: '🇷🇴',
  },
  {
    en: 'Russia',
    code: 'RU',
    iso3: 'RUS',
    zone: '7',
    emoji: '🇷🇺',
  },
  {
    en: 'Rwanda',
    code: 'RW',
    iso3: 'RWA',
    zone: '250',
    emoji: '🇷🇼',
  },
  {
    en: 'Saint Helena',
    code: 'SH',
    iso3: 'SHN',
    zone: '290',
    emoji: '🇸🇭',
  },
  {
    en: 'Saint Kitts and Nevis',
    code: 'KN',
    iso3: 'KNA',
    zone: '1-869',
    emoji: '🇰🇳',
  },
  {
    en: 'Saint Lucia',
    code: 'LC',
    iso3: 'LCA',
    zone: '1-758',
    emoji: '🇱🇨',
  },
  {
    en: 'Saint Pierre and Miquelon',
    code: 'PM',
    iso3: 'SPM',
    zone: '508',
    emoji: '🇵🇲',
  },
  {
    en: 'Saint Vincent and the Grenadines',
    code: 'VC',
    iso3: 'VCT',
    zone: '1-784',
    emoji: '🇻🇨',
  },
  {
    en: 'Saint-Barthelemy',
    code: 'BL',
    iso3: 'BLM',
    zone: '590',
    emoji: '🇧🇱',
  },
  {
    en: 'Saint-Martin (French part)',
    code: 'MF',
    iso3: 'MAF',
    zone: '590',
    emoji: '🇲🇫',
  },
  {
    en: 'Samoa',
    code: 'WS',
    iso3: 'WSM',
    zone: '685',
    emoji: '🇼🇸',
  },
  {
    en: 'San Marino',
    code: 'SM',
    iso3: 'SMR',
    zone: '378',
    emoji: '🇸🇲',
  },
  {
    en: 'Sao Tome and Principe',
    code: 'ST',
    iso3: 'STP',
    zone: '239',
    emoji: '🇸🇹',
  },
  {
    en: 'Saudi Arabia',
    code: 'SA',
    iso3: 'SAU',
    zone: '966',
    emoji: '🇸🇦',
  },
  {
    en: 'Senegal',
    code: 'SN',
    iso3: 'SEN',
    zone: '221',
    emoji: '🇸🇳',
  },
  {
    en: 'Serbia',
    code: 'RS',
    iso3: 'SRB',
    zone: '381',
    emoji: '🇷🇸',
  },
  {
    en: 'Seychelles',
    code: 'SC',
    iso3: 'SYC',
    zone: '248',
    emoji: '🇸🇨',
  },
  {
    en: 'Sierra Leone',
    code: 'SL',
    iso3: 'SLE',
    zone: '232',
    emoji: '🇸🇱',
  },
  {
    en: 'Singapore',
    code: 'SG',
    iso3: 'SGP',
    zone: '65',
    emoji: '🇸🇬',
  },
  {
    en: 'Sint Maarten (Dutch part)',
    code: 'SX',
    iso3: 'SXM',
    zone: '1721',
    emoji: '🇸🇽',
  },
  {
    en: 'Slovakia',
    code: 'SK',
    iso3: 'SVK',
    zone: '421',
    emoji: '🇸🇰',
  },
  {
    en: 'Slovenia',
    code: 'SI',
    iso3: 'SVN',
    zone: '386',
    emoji: '🇸🇮',
  },
  {
    en: 'Solomon Islands',
    code: 'SB',
    iso3: 'SLB',
    zone: '677',
    emoji: '🇸🇧',
  },
  {
    en: 'Somalia',
    code: 'SO',
    iso3: 'SOM',
    zone: '252',
    emoji: '🇸🇴',
  },
  {
    en: 'South Africa',
    code: 'ZA',
    iso3: 'ZAF',
    zone: '27',
    emoji: '🇿🇦',
  },
  {
    en: 'South Georgia',
    code: 'GS',
    iso3: 'SGS',
    zone: '500',
    emoji: '🇬🇸',
  },
  {
    en: 'South Korea',
    code: 'KR',
    iso3: 'KOR',
    zone: '82',
    emoji: '🇰🇷',
  },
  {
    en: 'South Sudan',
    code: 'SS',
    iso3: 'SSD',
    zone: '211',
    emoji: '🇸🇸',
  },
  {
    en: 'Spain',
    code: 'ES',
    iso3: 'ESP',
    zone: '34',
    emoji: '🇪🇸',
  },
  {
    en: 'Sri Lanka',
    code: 'LK',
    iso3: 'LKA',
    zone: '94',
    emoji: '🇱🇰',
  },
  {
    en: 'Sudan',
    code: 'SD',
    iso3: 'SDN',
    zone: '249',
    emoji: '🇸🇩',
  },
  {
    en: 'Suriname',
    code: 'SR',
    iso3: 'SUR',
    zone: '597',
    emoji: '🇸🇷',
  },
  {
    en: 'Svalbard and Jan Mayen Islands',
    code: 'SJ',
    iso3: 'SJM',
    zone: '47',
    emoji: '🇸🇯',
  },
  {
    en: 'Sweden',
    code: 'SE',
    iso3: 'SWE',
    zone: '46',
    emoji: '🇸🇪',
  },
  {
    en: 'Switzerland',
    code: 'CH',
    iso3: 'CHE',
    zone: '41',
    emoji: '🇨🇭',
  },
  {
    en: 'Syria',
    code: 'SY',
    iso3: 'SYR',
    zone: '963',
    emoji: '🇸🇾',
  },
  {
    en: 'Taiwan',
    code: 'TW',
    iso3: 'TWN',
    zone: '886',
    emoji: '🇹🇼',
  },
  {
    en: 'Tajikistan',
    code: 'TJ',
    iso3: 'TJK',
    zone: '992',
    emoji: '🇹🇯',
  },
  {
    en: 'Tanzania',
    code: 'TZ',
    iso3: 'TZA',
    zone: '255',
    emoji: '🇹🇿',
  },
  {
    en: 'Thailand',
    code: 'TH',
    iso3: 'THA',
    zone: '66',
    emoji: '🇹🇭',
  },
  {
    en: 'The Bahamas',
    code: 'BS',
    iso3: 'BHS',
    zone: '1-242',
    emoji: '🇧🇸',
  },
  {
    en: 'Timor-Leste',
    code: 'TL',
    iso3: 'TLS',
    zone: '670',
    emoji: '🇹🇱',
  },
  {
    en: 'Togo',
    code: 'TG',
    iso3: 'TGO',
    zone: '228',
    emoji: '🇹🇬',
  },
  {
    en: 'Tokelau',
    code: 'TK',
    iso3: 'TKL',
    zone: '690',
    emoji: '🇹🇰',
  },
  {
    en: 'Tonga',
    code: 'TO',
    iso3: 'TON',
    zone: '676',
    emoji: '🇹🇴',
  },
  {
    en: 'Trinidad and Tobago',
    code: 'TT',
    iso3: 'TTO',
    zone: '1-868',
    emoji: '🇹🇹',
  },
  {
    en: 'Tunisia',
    code: 'TN',
    iso3: 'TUN',
    zone: '216',
    emoji: '🇹🇳',
  },
  {
    en: 'Turkey',
    code: 'TR',
    iso3: 'TUR',
    zone: '90',
    emoji: '🇹🇷',
  },
  {
    en: 'Turkmenistan',
    code: 'TM',
    iso3: 'TKM',
    zone: '993',
    emoji: '🇹🇲',
  },
  {
    en: 'Turks and Caicos Islands',
    code: 'TC',
    iso3: 'TCA',
    zone: '1-649',
    emoji: '🇹🇨',
  },
  {
    en: 'Tuvalu',
    code: 'TV',
    iso3: 'TUV',
    zone: '688',
    emoji: '🇹🇻',
  },
  {
    en: 'Uganda',
    code: 'UG',
    iso3: 'UGA',
    zone: '256',
    emoji: '🇺🇬',
  },
  {
    en: 'Ukraine',
    code: 'UA',
    iso3: 'UKR',
    zone: '380',
    emoji: '🇺🇦',
  },
  {
    en: 'United Arab Emirates',
    code: 'AE',
    iso3: 'ARE',
    zone: '971',
    emoji: '🇦🇪',
  },
  {
    en: 'United Kingdom',
    code: 'GB',
    iso3: 'GBR',
    zone: '44',
    emoji: '🇬🇧',
  },
  {
    en: 'United States',
    code: 'US',
    iso3: 'USA',
    zone: '1',
    emoji: '🇺🇸',
  },
  {
    en: 'United States Minor Outlying Islands',
    code: 'UM',
    iso3: 'UMI',
    zone: '1',
    emoji: '🇺🇲',
  },
  {
    en: 'Uruguay',
    code: 'UY',
    iso3: 'URY',
    zone: '598',
    emoji: '🇺🇾',
  },
  {
    en: 'Uzbekistan',
    code: 'UZ',
    iso3: 'UZB',
    zone: '998',
    emoji: '🇺🇿',
  },
  {
    en: 'Vanuatu',
    code: 'VU',
    iso3: 'VUT',
    zone: '678',
    emoji: '🇻🇺',
  },
  {
    en: 'Vatican City State (Holy See)',
    code: 'VA',
    iso3: 'VAT',
    zone: '379',
    emoji: '🇻🇦',
  },
  {
    en: 'Venezuela',
    code: 'VE',
    iso3: 'VEN',
    zone: '58',
    emoji: '🇻🇪',
  },
  {
    en: 'Vietnam',
    code: 'VN',
    iso3: 'VNM',
    zone: '84',
    emoji: '🇻🇳',
  },
  {
    en: 'Virgin Islands (British)',
    code: 'VG',
    iso3: 'VGB',
    zone: '1-284',
    emoji: '🇻🇬',
  },
  {
    en: 'Virgin Islands (US)',
    code: 'VI',
    iso3: 'VIR',
    zone: '1-340',
    emoji: '🇻🇮',
  },
  {
    en: 'Wallis and Futuna Islands',
    code: 'WF',
    iso3: 'WLF',
    zone: '681',
    emoji: '🇼🇫',
  },
  {
    en: 'Western Sahara',
    code: 'EH',
    iso3: 'ESH',
    zone: '212',
    emoji: '🇪🇭',
  },
  {
    en: 'Yemen',
    code: 'YE',
    iso3: 'YEM',
    zone: '967',
    emoji: '🇾🇪',
  },
  {
    en: 'Zambia',
    code: 'ZM',
    iso3: 'ZMB',
    zone: '260',
    emoji: '🇿🇲',
  },
  {
    en: 'Zimbabwe',
    code: 'ZW',
    iso3: 'ZWE',
    zone: '263',
    emoji: '🇿🇼',
  },
];

export default countryCode;
